export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const TOGGLE_FEED_LIST_VIEW = 'TOGGLE_FEED_LIST_VIEW';
export const TOGGLE_HOME_PAGE= 'TOGGLE_HOME_PAGE';
